import { CustomScrollbar } from '@shared/components/CustomScrollbar';
import { StatusLabel } from '@shared/components/StatusLabel';
import { TERMINOLOGY } from '@shared/i18n';
import { PROJECT_DETAILS_MAX_WIDTH_PX } from '../../constants';
import type { TProject } from '../../types';
import { useProjectDashboard } from '../../tasks/api';
import type { ETaskStatus, TTaskListItem } from '../../tasks/types';
import NeedsAttentionSection from './NeedsAttentionSection';
import RecentActivitiesCard from './RecentActivitiesCard';
import TaskProgressCard from './TaskProgressCard';

type TProps = {
  project: Pick<TProject, '_id'>;
  statusPending: boolean;
  onStatusChange: (task: TTaskListItem, status: ETaskStatus) => void;
};

const ProjectDashboard = ({ project, statusPending, onStatusChange }: TProps) => {
  const { data, error } = useProjectDashboard(project._id);
  return (
    <CustomScrollbar className="min-h-0 flex-1">
      <div
        className="mx-auto flex w-full flex-col gap-10 pl-5 pr-8 pb-6"
        style={{ maxWidth: PROJECT_DETAILS_MAX_WIDTH_PX }}
      >
        <StatusLabel
          data={data}
          error={error}
          loadingMessage="Loading dashboard..."
          errorMessage={`Loading the ${TERMINOLOGY.project.lower} dashboard failed!`}
          render={(dashboard) =>
            Object.values(dashboard.statusCounts).some(Boolean) || dashboard.activities.length ? (
              <>
                <div className="flex flex-wrap gap-5">
                  <TaskProgressCard statusCounts={dashboard.statusCounts} />
                  <RecentActivitiesCard projectId={project._id} activities={dashboard.activities} />
                </div>
                <NeedsAttentionSection
                  projectId={project._id}
                  needsAttention={dashboard.needsAttention}
                  statusPending={statusPending}
                  onStatusChange={onStatusChange}
                />
              </>
            ) : (
              <p className="text-neutral-500 py-8">No {TERMINOLOGY.task.lowerPlural} yet.</p>
            )
          }
        />
      </div>
    </CustomScrollbar>
  );
};
export default ProjectDashboard;
